import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UtilityService } from '../../../../core/services/utility.service';
import { ChecklistService } from '../../../../pages/checklist/services/checklist.service';
import { OrderByPipe } from '../../../../shared/pipe/order-by.pipe';


@Component({
  selector: 'app-advance-item-modal',
  templateUrl: './advance-item-modal.component.html',
  styleUrls: ['./advance-item-modal.component.css']
})
export class AdvanceItemModalComponent implements OnInit {
  @Input() item: any;
  @Input() mode: string;
  @Input() itemGroup: any;
  @Input() templateId: number;
  @Input() itemGroups: any;
  @Input() index: number;
  @Input() dropdownTypeList: any[];

  orderByPipe: OrderByPipe
  formData: { [key: string]: any } = {};
  personalInfoList: any[] = [];
  lastSave: { [key: string]: any } = {};

  constructor(private utilityService: UtilityService, private checklistService: ChecklistService, public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
    this.orderByPipe = new OrderByPipe();
    this.personalInfoList = [{ value: "Address1", display: "Address 1" }, { value: "Address2", display: "Address 2" }, { value: "Birthday", display: "Birthday" }, { value: "City", display: "City" }, { value: "Cell", display: "Cell" },
    { value: "Country", display: "Country" }, { value: "Email", display: "Email" }, { value: "FirstName", display: "First Name" }, { value: "LastName", display: "Last Name" }, { value: "MidName", display: "Middle Name" },
    { value: "Phone", display: "Phone" }, { value: "Suffix", display: "Suffix" }, { value: "State", display: "State" }, { value: "Zip", display: "Zip" }];

  }

  fadeLabel(status: boolean) {
    this.formData.labelFade = false;
    this.lastSave = this.utilityService.fadeLabel(status);
    setTimeout(() => {
      this.formData.labelFade = true;
    }, 2000);
  }

  toggleActive() {
    this.checklistService.templateItemToggleActive(this.item.ChecklistTemplateItemID, this.item.IsActive).then((response: any) => {
      if (response != null) {
        this.fadeLabel(response.success);
        this.getChecklistItems();
      }
    });
  }

  closeClicked() {
    this.activeModal.dismiss();
  }

  updateItem(item: any, templateID: number) {
    this.updateShowTH();
    let requestObj = { checklistTemplateItemID: item.ChecklistTemplateItemID, checklistTemplateItemGrpID: item.ChecklistTemplateItemGrpID, responseTypeID: item.ResponseTypeID, itemPrompt: item.ItemPrompt, itemNumber: item.ItemNumber, itemLongPrompt: item.ItemLongPrompt, checklistLookupID: item.ChecklistLookupID, maxResponseLength: item.MaxResponseLength, validationRegex: item.ValidationRegex, personalInfoField: item.PersonalInfoField, isAdminField: item.IsAdminField, isRequiredAttachment: (item.ShowAttachments ? item.IsRequiredAttachment : false), rebindDropdown: item.RebindDropdown, showComments: item.ShowComments ,showAttachments: item.ShowAttachments, isRequired: item.IsRequired };

    this.checklistService.addUpdateTemplateItem(requestObj).then((response: any) => { //handle ChecklistTemplateItemID refresh the after the new row update with id -1
      if (response != null) {
        this.fadeLabel(response.success);
        this.checklistService.getItemsByTemplateID(this.templateId).then((response: any) => {
          if (response != null) {
            var temp = response;
            temp = this.orderByPipe.transform(temp, ["ItemGrpName", "ChecklistTemplateItemID"], "asc");
            var newIndex = 0;
            temp.forEach((val: any) => {
              if (val.ChecklistTemplateItemGrpID == templateID) {
                newIndex = val.ChecklistTemplateItemID
              }
            })
            this.itemGroups.forEach((val: any) => {
              if (val.ChecklistTemplateItemGrpID == templateID) {
                if (val.Items[this.index].ChecklistTemplateItemID == -1)
                  val.Items[this.index].ChecklistTemplateItemID = newIndex;
              }
            })
          }
        });
      }
    });
  }

  getChecklistItems() {
    this.itemGroups.forEach((val: any) => {
      val.Items = [];
    });
    this.checklistService.getItemsByTemplateID(this.templateId).then((response: any) => {
      if (response != null) {
        response.forEach((val: any) => {
          this.itemGroups.forEach((group: any) => {
            if (val.ChecklistTemplateItemGrpID == group.ChecklistTemplateItemGrpID) {
              group.Items.push(val);
            }
          });
        });
        this.updateShowTH();
      }
    });
  }

  updateShowTH() {
    if (this.itemGroups != null) {
      this.itemGroups.forEach((val: any) => {
        if (val != null) {
          var count = 0;
          val.Items.forEach((val2: any) => {
            if (val2.ResponseTypeID == 7 || val2.ResponseTypeID == 8 || val2.ResponseTypeID == 9 || val2.ResponseTypeID == 15) {
              count++;
              return false;
            }
          });
          if (count == 0)
            val.showTH = false;
          else
            val.showTH = true;
        }
      });
    }
  }

}



